// Mobile nav toggle — vanilla, accessible (aria-expanded + Escape to close).

export function initNav() {
  const header = document.querySelector('.site-header');
  const toggle = document.querySelector('.nav-toggle');
  if (!header || !toggle) return;

  const setOpen = (open) => {
    header.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  };

  toggle.addEventListener('click', () => {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });

  // Reset when resizing up to desktop so state doesn't get stuck.
  const mq = window.matchMedia('(min-width: 901px)');
  mq.addEventListener('change', (e) => {
    if (e.matches) setOpen(false);
  });
}
